export const COMPONENT_NAME = 'Infobox';
